let db = null;

export async function getDB() {
    if (!db) {
        const { Dexie } = await import('dexie/dist/modern/dexie.mjs');
        db = new Dexie('form');
        db.version(1).stores({ fields: '++id' });
    }

    return db;
}
